import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElmarknadensHistoria = lazy(() => import("@/pages/elmarknaden/ElmarknadensHistoria"));

export const Route = createFileRoute("/elmarknaden/historia")({
  head: () => seoHead("/elmarknaden/historia", { description: "Från 1880-talets första kraftverk och den stora vattenkraftsutbyggnaden till dagens nordiska elbörs." }),
  component: () => <ElmarknadensHistoria />,
});
